// extracted by mini-css-extract-plugin
export default {"avatarContainerBlk":"Avatar_avatarContainerBlk__Fy+QP"};